import React from 'react';
import { Feed, Icon } from 'semantic-ui-react';
import moment from 'moment';
import { IPtw, statusMap } from '@relab/alstom-ptw-shared';

import 'moment/locale/it';
import { TranslationComponent } from '../TranslationComponent';

moment.locale('it');

interface PtwDetailHistoryComponentProps {
  ptw: IPtw;
}

export const PtwDetailHistoryComponent = ({ ptw }: PtwDetailHistoryComponentProps) => (
  <React.Fragment>
    <Feed>
      {ptw.history.map((event) => (
        <Feed.Event key={event._id}>
          <Feed.Label>
            <Icon name="flag" />
          </Feed.Label>
          <Feed.Content>
            <Feed.Date>{moment(event.datetime).format('lll')}</Feed.Date>
            <Feed.Summary>
              <TranslationComponent
                stringKey={'{{name}} changed status to {{name_2}}'}
                values={{ name: event.author.name, name_2: statusMap[event.status].name }}
              />
            </Feed.Summary>
          </Feed.Content>
        </Feed.Event>
      ))}
    </Feed>
  </React.Fragment>
);
